<div class="table-row">
	@let r = getDataRow();
	@if (showDate()) {
		<div>{{ row().date | date: 'HH:mm' }}</div>
	}
	@if (medsItems) {
		@let med = medsItems?.[r.medication];
		@if (med) {
			<div class="font-decimaBold">{{ med.medication }}</div>
			<div class="ml-auto">{{ r.dosage }}mg</div>
		}
	}
</div>